<script>
import facebookIcon from '../../../../images/icons/facebookTwo.svg';
import instagramIcon from '../../../../images/icons/instagram.svg';
export default {
    props: {
        email: {
            type: String,
            required: true
        },
        phone: {
            type: String,
            required: true
        },
        head: {
            type: String,
            required: true
        },
        logo: {
            type: String,
            required: true
        },
        socialLinks: {
            type: Array,
            required: true
        }
    }
}
</script>
<template>
<div class="flex flex-col ml-5 w-[66%] max-md:ml-0 max-md:w-full">
  <div class="flex flex-col grow text-xl leading-none text-right text-zinc-900 max-md:mt-10 max-md:max-w-full">
    <div class="flex flex-col items-end self-end max-w-full w-[304px]">
      <img loading="lazy" :src="logo" alt="" class="object-contain aspect-square rounded-[800px] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] w-[91px] max-md:mr-2" />
      <h2 class="mt-10 text-2xl font-bold tracking-wider leading-loose text-violet-800 max-md:mr-2">
{{ head }}
    </h2>
      <div dir="rtl" class="flex flex-col items-start self-start max-w-full w-[304px]">
      <a 
        class="flex  gap-6 mt-4 whitespace-nowrap max-md:mr-0.5 hover:text-violet-800 focus:outline-none focus:ring-2 focus:ring-violet-800 focus:ring-offset-2 rounded transition-colors duration-300"
      >
        <svg
                  class="object-contain shrink-0 self-start aspect-square w-[21px]"
                 width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M1.73199 1.50492C1.39814 1.83914 1.09202 2.24912 0.894091 2.60611C0.645496 3.04243 0.461977 3.5209 0.351333 4.01836L0.293754 4.31893C-0.61363 8.92259 0.53874 13.0408 4.34285 16.8178C6.83881 19.296 8.73148 20.3144 11.323 20.6862C11.7429 20.7464 12.1816 20.7917 12.7035 20.8303L13.7766 20.8955C14.3754 20.9265 15.3732 20.9762 15.7138 20.9956C16.1624 21.0211 16.7559 20.9353 17.5536 20.7485L17.6744 20.7131C18.3707 20.4671 19.0065 20.0681 19.5389 19.5351C21.487 17.5848 21.487 14.4227 19.5389 12.4724L19.3653 12.3067C17.482 10.5918 14.6022 10.5761 12.7013 12.2681L12.476 12.472L11.2715 13.6778C11.0076 13.942 10.592 13.9778 10.2868 13.7626C9.65201 13.3149 7.96533 11.6641 7.5536 11.1014C7.32977 10.7956 7.36227 10.372 7.63013 10.104L8.69127 9.04233L8.78204 8.96848L8.9168 8.8436C8.94111 8.82019 8.96587 8.79589 8.99042 8.77131C10.9948 6.76475 10.9948 3.51148 8.99042 1.50492C6.98606 -0.50164 3.73635 -0.50164 1.73199 1.50492ZM3.36005 3.13476C4.46526 2.02834 6.25715 2.02834 7.36236 3.13476C8.46757 4.24119 8.46757 6.03505 7.36236 7.14147C7.29398 7.20992 7.22275 7.27442 7.14887 7.33488L6.00248 8.47373C4.93098 9.54597 4.80099 11.2403 5.69628 12.4636C6.25658 13.2293 8.12303 15.056 8.9608 15.6469L9.12244 15.7535C10.3249 16.4936 11.8897 16.3186 12.8996 15.3076L14.0131 14.1926L14.0283 14.1848L14.1356 14.0799C15.1864 13.0514 16.8702 13.0605 17.9108 14.1023C18.9598 15.1524 18.9598 16.8551 17.9108 17.9052L17.7319 18.0692C17.5469 18.2242 17.3443 18.3518 17.1284 18.4505L16.9541 18.5206L16.6582 18.5858L16.3456 18.6443C16.1105 18.6837 15.9401 18.6998 15.8446 18.6944L13.5069 18.5729L12.8875 18.5327L12.3503 18.4874C12.0984 18.4631 11.8691 18.436 11.6496 18.4045C9.57492 18.1069 8.12507 17.3268 5.96418 15.1813C2.82432 12.0638 1.8511 8.83902 2.49265 5.08977L2.55976 4.72529C2.62058 4.35199 2.73322 4.03032 2.90071 3.73627C3.00269 3.55249 3.18003 3.31499 3.36005 3.13476Z" fill="#5930AF"/>
</svg>
<span class="basis-auto">{{ phone }}</span>

    </a>
      
      <a 
      class="flex gap-6 self-start mt-6 ml-3.5 whitespace-nowrap max-md:ml-2.5 hover:text-violet-800 focus:outline-none focus:ring-2 focus:ring-violet-800 focus:ring-offset-2 rounded transition-colors duration-300"
    >
      <svg 
       class="object-contain shrink-0 self-start 
       aspect-[1.4] w-[21px]" 
        width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M3.15 0C1.4103 0 0 1.2592 0 2.8125V12.1875C0 13.7408 1.4103 15 3.15 15H17.85C19.5897 15 21 13.7408 21 12.1875V2.8125C21 1.2592 19.5897 0 17.85 0H3.15ZM2.96679 1.88922C3.02628 1.87987 3.0875 1.875 3.15 1.875H17.85C17.9125 1.875 17.9737 1.87988 18.0332 1.88923L10.5 6.37328L2.96679 1.88922ZM2.1 3.62674V12.1875C2.1 12.7053 2.5701 13.125 3.15 13.125H17.85C18.4299 13.125 18.9 12.7053 18.9 12.1875V3.62676L11.0824 8.28007C10.7298 8.49 10.2703 8.49 9.91758 8.28007L2.1 3.62674Z" fill="#5930AF"/>
</svg>
<span class="grow">{{ email }}</span>

    </a>
      </div>
      <div class="shrink-0 self-stretch mt-7 h-px border border-purple-500 border-solid" ></div>
      
      <div class="flex gap-4 mt-6 justify-center align-middle max-md:mr-2">
          <a 
            v-for="link in socialLinks"
            :key="link.id"
            :href="link.url"
            target="_blank"
            rel="noopener noreferrer"
            class="hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-violet-800 focus:ring-offset-2 rounded transition-opacity duration-300"
          >
            <div    
                                  
              v-html="$icon(link.id == 1 ? 'facebookTwo' : 'instagram')"
            alt="" class="object-contain w-[21px] h-[21px]" ></div>
          </a>
      </div>
    </div>
    
    <div class="self-start mt-20 max-md:mt-10">
      © {{new Date().getFullYear()}}, All Rights Reserved
    </div>
  </div>
</div>
</template>